import type { RestaurantConfig } from "../domain/types";

export const restaurantConfig: RestaurantConfig = {
  name: "Осень",
  shortDescription: "Городское кафе с завтраками весь день и современной европейской кухней.",
  address: "Москва, ул. Яузская, д. 8, стр. 2",
  phone: "+7 965 297-20-20",
  website: "https://osenyauza.ru/",
  mapUrl: "https://yandex.ru/maps/?pt=37.6470447202,55.746986733&z=17&l=map",
  timezone: "Europe/Moscow",
  allowInteractiveWhenClosed: true,
  interaction: { idleTimeoutSeconds: 45, warningSeconds: 10, showCountdown: true },
};
